import { Breadcrumb as AntBreadcrumb } from 'antd';
import { AiOutlineHome } from 'react-icons/ai';
import { Link, useLocation } from 'react-router-dom';

import { BreadcrumbContainer } from './styles';

const routeLabels: Record<string, string> = {
  '/': 'Início',
  '/arquivos': 'Documentos',
  '/solicitacoes': 'Notas Fiscais',
  '/configuracoes': 'Configurações',
  '/dividas-tributarias': 'Pendências Tributárias',
  '/extrato-bancario': 'Extrato Bancário',
};

export const Breadcrumb = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  if (isHome) {
    return null;
  }

  const currentLabel = routeLabels[location.pathname] || 'Página';

  return (
    <BreadcrumbContainer>
      <AntBreadcrumb>
        <AntBreadcrumb.Item>
          <Link to="/">
            <AiOutlineHome style={{ marginRight: 4 }} />
            Início
          </Link>
        </AntBreadcrumb.Item>
        <AntBreadcrumb.Item>{currentLabel}</AntBreadcrumb.Item>
      </AntBreadcrumb>
    </BreadcrumbContainer>
  );
};
